@if (!isSidebarLoading()) {
  <div class="h-full flex flex-col">
    <app-sidebar-header
      [showBackButton]="!isEdit || (currentPage$ | async) !== COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE"
      (backButtonClicked)="goBack()"
    >
      <div smallTitle>{{ isEdit ? 'Edit Contract' : 'Add Contract' }}</div>
      @if ((currentPage$ | async) === 1) {
        <div mainTitle>General Information</div>
      }
    </app-sidebar-header>

    <ng-scrollbar
      [ngClass]="{ 'first-page': (currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE }"
      class="std-scrollbar wider-track"
      appearance="compact"
      visibility="native"
      orientation="vertical"
    >
      <div
        [ngClass]="{ 'mb-5 mt-4 horizontal-spacing': (currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE }"
        class="scrollable-content"
      >
        @if ((currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE) {
          <form class="flex flex-col flex-1" #firstPageForm="ngForm" role="form" [@fadeInGeneral]>
            <div class="flex-1 flex flex-col">
              <app-upload-commitments-sidebar [commitmentType]="commitmentType"></app-upload-commitments-sidebar>
              <div class="flex justify-between items-center gap-2.5">
                @if (isCompanyInput) {
                  <app-floating-input
                    [(ngModel)]="model.service_provider.name"
                    [required]="true"
                    placeholder="Temporary Company Name"
                    label="Temporary Company Name"
                    name="serviceProviderUserId"
                    #serviceProviderUserId="ngModel"
                    (change)="updateContract()"
                    (iconClick)="revertToDropDown($event, serviceProviderUserId)"
                    class="flex-1"
                    iconClass="icon icon-add cursor-pointer hover:text-red-500 before:rotate-45"
                  ></app-floating-input>
                } @else {
                  <app-floating-input
                    [(ngModel)]="model.service_provider.name"
                    [required]="true"
                    [readonly]="true"
                    [disabled]="isFreeSP"
                    (click)="companyNameDropdownClicked()"
                    #optionsTrigger="cdkOverlayOrigin"
                    #serviceProviderModel="ngModel"
                    cdkOverlayOrigin
                    class="flex-1 cursor-pointer"
                    id="serviceProviderUserId"
                    name="serviceProviderUserId"
                    label="Company Name"
                    [iconClass]="
                      isFreeSP
                        ? null
                        : isDropdownShown.service_provider
                          ? 'dropdown-icon opened'
                          : 'dropdown-icon closed'
                    "
                  >
                  </app-floating-input>
                  <app-overlay-general
                    [(show)]="isDropdownShown.service_provider"
                    [trigger]="optionsTrigger"
                    [overlayPositions]="dropdownOverlayPositions"
                  >
                    <app-company-dropdown
                      (optionSelected)="selectedCompany($event, serviceProviderModel)"
                      [hideAddCompany]="!user?.isPaidAccount"
                    ></app-company-dropdown>
                  </app-overlay-general>
                }
                <app-floating-input
                  id="title"
                  label="Contract Title"
                  placeholder="Contract Title"
                  name="title"
                  (change)="updateContract()"
                  [(ngModel)]="model.title"
                  class="flex-1"
                  required
                ></app-floating-input>
              </div>
              <div class="flex justify-between items-center gap-2.5">
                <app-input-calendar
                  #added_at_calendar
                  [required]="true"
                  [date]="model.added_at"
                  [minStartDate]="projectData?.start_date"
                  [maxDate]="firstSpendEntryDate"
                  (dateChanged)="updateContractDate($event)"
                  placeholder="Contract Date"
                  class="w-full"
                  [showIcon]="true"
                ></app-input-calendar>
                <app-dropdown
                  [optionLabel]="null"
                  [optionValue]="null"
                  [disabled]="
                    (hasCommitments$ | async) ||
                    (!user.isPaidAccount && model?.approval_status === COMMITMENT_APPROVAL_STATUS.APPROVED)
                  "
                  [required]="true"
                  placeholder="Contract Status"
                  label="Contract Status"
                  id="approval_status"
                  name="approval_status"
                  [(ngModel)]="model.approval_status"
                  (ngModelChange)="updateContract()"
                  [options]="getApprovalStatuses()"
                  class="w-full"
                >
                  <ng-template #selectedContent #optionContent let-option>
                    <div class="capitalize text-navy-900 text-medium">{{ option }}</div>
                  </ng-template>
                </app-dropdown>
              </div>
              <app-floating-textarea
                [autoResize]="false"
                class="w-full"
                id="description"
                name="description"
                [(ngModel)]="model.description"
                (change)="updateContract()"
                label="Contract Description (optional)"
                placeholder="Contract Description (optional)"
              ></app-floating-textarea>
            </div>
          </form>
        } @else {
          <div [@fadeInGeneral]>
            @for (entry of spendEntriesData; track $index) {
              <div>
                <app-spend-entry
                  #spendEntries
                  [commitmentAddedAt]="model.added_at"
                  [model]="entry"
                  [projectData]="projectData"
                  [index]="$index"
                  [commitmentType]="COMMITMENTS_INTERACTION_BAR_TYPE.ADD_CONTRACT"
                  [disableAddDescription]="model.approval_status === COMMITMENT_APPROVAL_STATUS.APPROVED && !!model?.id"
                  [disableRemoveEntry]="model.approval_status === COMMITMENT_APPROVAL_STATUS.APPROVED && !!model?.id"
                  [disabledAddDescriptionTooltip]="
                    model.approval_status === COMMITMENT_APPROVAL_STATUS.APPROVED && !!model?.id
                      ? 'Cannot add description to an approved contract'
                      : 'Select a line item first'
                  "
                ></app-spend-entry>
              </div>
            }
            <div class="horizontal-spacing mt-5 mb-2">
              <app-simple-button
                size="large"
                [wrapperClass]="{
                  'border-2 bg-transparent w-full rounded-[3px] ': true,
                  'border-blue-700 text-blue-700': (canAddContractSpendEntries$ | async),
                  'border-navy-500 text-navy-500': !(canAddContractSpendEntries$ | async),
                }"
                (click)="addSpendEntry()"
                [disabled]="!(canAddContractSpendEntries$ | async)"
                >Add Spend Entry
              </app-simple-button>
            </div>
          </div>
        }
      </div>
    </ng-scrollbar>
    <div
      [ngClass]="{
        bordered: (currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.LAST_PAGE,
      }"
      class="bottom-container text-navy-700 text-base font-bold"
    >
      <span [ngClass]="{ invisible: (currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE }" class="flex-1"
        >Total Contract</span
      >
      <span
        class="flex-1 justify-center flex"
        [ngClass]="{
          negative: (totalContractCost$ | async) < 0,
          invisible: (currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE,
        }"
      >
        @if ((totalContractCost$ | async) !== 0) {
          <span>{{ totalContractCost$ | async | money: 'positiveComa' }}</span>
        }
        @if ((totalContractCost$ | async) === 0) {
          <span>$ {{ totalContractCost$ | async | number }}</span>
        }
      </span>
      <div class="flex items-center">
        @if ((currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE && !isLoading) {
          <app-simple-button
            [wrapperClass]="{
              rounded: true,
            }"
            [disabled]="isLoading"
            (click)="incrementPage()"
          >
            Next
          </app-simple-button>
        } @else if (!isLoading) {
          <app-simple-button
            [wrapperClass]="{
              'bg-yellow-500 rounded': true,
            }"
            [disabled]="isLoading"
            (click)="save()"
          >
            Submit
          </app-simple-button>
        } @else {
          <app-simple-button
            [wrapperClass]="{
              rounded: true,
            }"
            [disabled]="isLoading"
          >
            <span class="icon-refresh animate-spin"></span>
          </app-simple-button>
        }
      </div>
    </div>
  </div>
} @else {
  <div class="flex w-full h-full items-center justify-center">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
